import { Resources } from './resources'
import { templateUserId } from '../constants/index'

class TemplatesResource extends Resources {
  index () {
    return this.http.get( `${this.baseUrl}?id=${templateUserId}` )
  }
}

export default new TemplatesResource( 'templates' )


// WEBPACK FOOTER //
// ./src/resources/templates.js